<ng-container *ngIf="person">
    <div class="page-container page-container-vertical">
        <ng-content></ng-content>
    </div>

    <isav-content-type-view [singleColumn]="true">
        <div isavContentTypeDetails class="columns is-multiline">
            <div
                class="column is-6-tablet is-4-widescreen is-4-fullhd is-flex is-justify-content-center is-align-items-center"
            >
                <img
                    *ngIf="person.profileImage"
                    isavContentTypeAside
                    [isavApiImg]="person.profileImage"
                    alt=""
                    aria-hidden="true"
                    class="is-fullwidth is-containing is-max-vh"
                />
                <isav-image-caption [iri]="person.profileImage"></isav-image-caption>
            </div>
            <div class="column is-6-tablet is-3-widescreen is-4-fullhd">
                <div class="mb-4">
                    <p class="title is-5">Contact information</p>
                    <ng-container *isavAuthenticated="true; else notLogged">
                        <p><b>Email: </b> {{person.email}}</p>
                        <p><b>Phone: </b> {{person.phone}}</p>
                    </ng-container>
                    <ng-template #notLogged>
                        <div class="contact-information">
                            <h2 class="has-text-centered is-print-hidden">
                                <strong>
                                    Please
                                    <a
                                        routerLink="/sign-in"
                                        [queryParams]="{ returnUrl: router.url }"
                                        >login</a
                                    >
                                    to see contact information
                                </strong>
                            </h2>
                        </div>
                    </ng-template>
                </div>

                <div class="mb-4">
                    <p class="title is-5">Core information</p>
                    <p>
                        <strong>Organisation: </strong>
                        <isav-taxonomies-external-link
                            [iris]="[person.organisation]"
                        ></isav-taxonomies-external-link>
                    </p>
                    <p>
                        <b>Organisation link: </b>
                        <a [href]="person.organisationLink?.url" target="_blank"
                            >{{ person.organisationLink?.title }}</a
                        >
                    </p>
                    <p><b>Location: </b> {{person.location | isavGeoLocation}}</p>
                    <p>
                        <b>Profile type: </b>
                        <isav-taxonomies-names
                            [iris]="[person.userProfileType]"
                        ></isav-taxonomies-names>
                    </p>
                    <p>
                        <b> CV: </b>
                        <ng-container *ngFor="let link of person.linksToCV; let last = last;">
                            <a href="{{link.url}}" target="_blank">{{link.title}}</a>
                            <ng-container *ngIf="!last">, </ng-container>
                        </ng-container>
                    </p>
                    <p><b>Address: </b> {{person.address}}</p>
                    <p><b>Area code: </b> {{person.zipcode}}</p>
                    <p><b>City: </b> {{person.city}}</p>
                    <p>
                        <b>Country: </b>
                        <isav-taxonomies-names
                            [iris]="person.country ? [person.country] : []"
                        ></isav-taxonomies-names>
                    </p>
                    <p>
                        <b>Interests: </b>
                        <isav-taxonomies-names
                            [iris]="person.fieldOfInterests"
                        ></isav-taxonomies-names>
                    </p>
                    <p>
                        <b>Expertises: </b>
                        <isav-taxonomies-names [iris]="person.expertises"></isav-taxonomies-names>
                    </p>
                </div>
            </div>
            <div
                class="column is-12-tablet is-5-widescreen is-4-fullhd is-flex is-justify-content-center is-align-items-center"
            >
                <isav-map
                    [hideControls]="true"
                    [showFullScreenBtn]="true"
                    [centerCoords]="person.location | isavMapCoordinate"
                    [fullWidth]="true"
                    [type]='isGlobalMap ? "WorldStreetMap" : "Greenland"'
                >
                    <isav-map-vector-layer>
                        <isav-map-marker
                            *ngIf="person.location"
                            [coordinate]="person.location | isavMapCoordinate"
                            display="point"
                            [center]="true"
                        ></isav-map-marker>
                    </isav-map-vector-layer>
                </isav-map>
            </div>
        </div>
    </isav-content-type-view>

    <isav-page-content>
        <h2 class="title is-2">Person details</h2>
        <isav-content-editor-display [content]="person.description"></isav-content-editor-display>
    </isav-page-content>
</ng-container>
